import { render, staticRenderFns } from "./References.vue?vue&type=template&id=0c98a274&scoped=true&"
import script from "./References.vue?vue&type=script&lang=js&"
export * from "./References.vue?vue&type=script&lang=js&"
import style0 from "./References.vue?vue&type=style&index=0&id=0c98a274&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c98a274",
  null
  
)

export default component.exports